import React from 'react';
import { HStack, Text } from '@chakra-ui/react';
import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';

import { formatPhone, standaloneToast } from 'utils';

type CopyClipBoardProps = {
  initialValue: string;
  showCharacterLength?: number;
  phoneFormatter?: boolean;
  full?: boolean;
};
const CopyClipBoard: React.FC<CopyClipBoardProps> = ({
  initialValue,
  showCharacterLength,
  phoneFormatter = false,
  full = false,
}: CopyClipBoardProps) => {
  const valueRef = React.useRef(initialValue);
  const [hasCopied, setHasCopied] = React.useState(false);

  React.useEffect(() => {
    valueRef.current = initialValue;
  }, [initialValue]);

  const displayValue =
    showCharacterLength && initialValue.length > showCharacterLength
      ? initialValue.slice(0, showCharacterLength) + '...'
      : phoneFormatter
        ? formatPhone(initialValue)
        : initialValue;

  return (
    <HStack
      border="1px dashed"
      borderRadius={10}
      p={2}
      borderColor="primary"
      color="body"
      onClick={() => {
        void navigator.clipboard.writeText(valueRef.current);
        setHasCopied(true);
        window.setTimeout(() => setHasCopied(false), 2000);
        standaloneToast({
          position: 'top-right',
          description: 'Copied to clipboard',
          status: 'info',
          duration: 2000,
          isClosable: true,
        });
      }}
      cursor="pointer"
      justify="space-between"
      w={full ? '100%' : 'unset'}
    >
      <Text
        color={hasCopied ? 'primary' : 'body2'}
        minW="120px"
        maxW={full ? '85%' : 'unset'}
        wordBreak={full ? 'break-all' : 'unset'}
      >
        {displayValue}
      </Text>
      <CopyIcon />
    </HStack>
  );
};
export default CopyClipBoard;
